(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    api.init(root.document);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var STICKY = '[data-sticky-addtocart].bi-cro-sticky';
  var IN_VIEW = 'bi-cro-form-in-view';

  function syncSoldOutLabel(sticky) {
    var atc = sticky.querySelector('[data-action-atc]');
    var list = sticky.querySelector('[data-sticky-select]');
    var label = sticky.querySelector('[data-sticky-v-title] [data-dropdown-open] > span');
    if (!atc || !list || !label) return false;
    var id = atc.getAttribute('data-variant-id');
    if (!/^\d+$/.test(id || '')) return false;
    var item = list.querySelector('[data-dropdown-item][data-value="' + id + '"]');
    if (!item || !item.hasAttribute('disabled')) return false;
    var title = item.getAttribute('data-bi-title');
    if (title && label.textContent !== title) label.textContent = title;
    var selected = list.querySelectorAll('[data-dropdown-item].is--selected');
    for (var i = 0; i < selected.length; i++) {
      if (selected[i] !== item) selected[i].classList.remove('is--selected');
    }
    item.classList.add('is--selected');
    return true;
  }

  function watchForm(doc, sticky) {
    var form = doc.getElementById(sticky.getAttribute('data-bi-cro-form') || '');
    var win = doc.defaultView;
    if (!form || !win || !win.IntersectionObserver) return;
    var mobile = win.matchMedia('(max-width: 767px)');
    new win.IntersectionObserver(function (entries) {
      var inView = entries[entries.length - 1].isIntersecting;
      doc.body.classList.toggle(IN_VIEW, inView);
      if (!inView || !mobile.matches || !sticky.classList.contains('sticky_layout_mb--default')) return;
      var open = sticky.querySelector('[data-dropdown-open].is--clicked');
      if (open) open.click();
    }).observe(form);
  }

  function bind(doc, sticky) {
    var atc = sticky.querySelector('[data-action-atc]');
    var win = doc.defaultView;
    if (atc && sticky.querySelector('[data-sticky-select]') && win.MutationObserver) {
      new win.MutationObserver(function () {
        syncSoldOutLabel(sticky);
      }).observe(atc, { attributes: true, attributeFilter: ['data-variant-id'] });
    }
    watchForm(doc, sticky);
  }

  function init(doc) {
    var sticky = doc.querySelector(STICKY);
    if (sticky) return bind(doc, sticky);
    var win = doc.defaultView;
    if (!win || !win.MutationObserver || !doc.body) return;
    var mo = new win.MutationObserver(function () {
      var found = doc.querySelector(STICKY);
      if (!found) return;
      mo.disconnect();
      bind(doc, found);
    });
    mo.observe(doc.body, { childList: true, subtree: true });
  }

  return { init: init, syncSoldOutLabel: syncSoldOutLabel };
});
